import { render, staticRenderFns } from "./regester.vue?vue&type=template&id=63a318d4&scoped=true&"
import script from "./regester.vue?vue&type=script&lang=js&"
export * from "./regester.vue?vue&type=script&lang=js&"
import style0 from "./regester.vue?vue&type=style&index=0&id=63a318d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a318d4",
  null
  
)

export default component.exports